import React from 'react';

import UserInfo from 'admin-moderator/components/MaterialUser/UserInfo';
import ColumnInfo from 'admin-moderator/components/MaterialUser/ColumnInfo';

import Avatar from './Avatar';
import LineStub from './LineStub';

function MaterialUserStub() {
  return (
    <UserInfo>
      <Avatar />

      <ColumnInfo>
        <LineStub style={{ width: '250px' }} />
      </ColumnInfo>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <LineStub style={{ width: '250px' }} />
      </div>
    </UserInfo>
  );
}

export default MaterialUserStub;
